import { render, staticRenderFns } from "./YoutubeClaimLog.vue?vue&type=template&id=864137da"
import script from "./YoutubeClaimLog.vue?vue&type=script&lang=js"
export * from "./YoutubeClaimLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports